import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "dropdown", "label"]

  connect() {
    // Close dropdown when clicking outside
    this.clickOutsideHandler = (event) => {
      if (!this.element.contains(event.target)) {
        this.close()
      }
    }
    document.addEventListener("click", this.clickOutsideHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
  }

  toggle(event) {
    event.preventDefault()
    this.dropdownTarget.classList.toggle("hidden")
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
  }

  select(event) {
    event.preventDefault()
    const button = event.currentTarget
    const value = button.dataset.value
    const label = button.dataset.label
    const dotColor = button.dataset.dot

    // Update hidden input
    this.inputTarget.value = value

    // Update button label with dot
    if (dotColor) {
      this.labelTarget.innerHTML = `
        <span class="w-2.5 h-2.5 rounded-full ${dotColor} mr-2"></span>
        <span>${label}</span>
      `
    } else {
      this.labelTarget.innerHTML = `<span class="text-gray-500">${label}</span>`
    }

    this.close()
  }
}
